import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Divider = _resolveComponent("Divider")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.styles, (style, index) => {
    return (_openBlock(), _createElementBlock("div", {
      class: "d-inline-block",
      key: style.category
    }, [
      _createVNode(_component_router_view, null, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_KeepAlive, null, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.styles[index].component), {
              ref_for: true,
              ref: "component",
              styles: _ctx.styles[index],
              onUpdateStyleEvent: _ctx.updateStyle
            }, null, 40, ["styles", "onUpdateStyleEvent"]))
          ], 1024))
        ]),
        _: 2
      }, 1024),
      (index != _ctx.styles.length - 1)
        ? (_openBlock(), _createBlock(_component_Divider, {
            key: 0,
            class: "d-inline-block",
            layout: "vertical"
          }))
        : _createCommentVNode("", true)
    ]))
  }), 128))
}